/**
 * Fork overlay (new file, no OSS equivalent) — EVA-M7 (7.4).
 * The curated model list the assistant form offers as a dropdown
 * (/api/v1/accounts/:account_id/eva/models → { default, models }).
 */
import ApiClient from 'dashboard/api/ApiClient';

class EvaModelsAPI extends ApiClient {
  constructor() {
    super('eva/models', { accountScoped: true });
  }
}

export default new EvaModelsAPI();
